"use client";

import Box from "@mui/material/Box";
import { FormFunnelRichText } from "@portal/app/_components/formFunnel/FormFunnelRichText";
import { usePuckSurfaceTone } from "../surfaceTone";
import type { PageChromeBlockProps } from "../pageChromeTypes";
import type { PageMedia } from "../../types";
import { hydratePuckRichTextMedia } from "../designHelpers";

export function PageDisclosure({
  label,
  content,
  openByDefault,
  inert = true,
  appearance = "standard",
  media = [],
}: PageChromeBlockProps["Disclosure"] & { inert?: boolean; media?: PageMedia[] }) {
  const onBrand = usePuckSurfaceTone("transparent") === "brand";
  const supporting = appearance === "supporting";
  return (
    <Box
      data-supporting-block
      component="details"
      open={openByDefault}
      sx={{
        width: "100%",
        color: onBrand ? "common.white" : "text.secondary",
        fontSize: "0.75rem",
        ...(onBrand
          ? {
              "&& > div, && h1, && h2, && h3, && h4, && h5, && h6, && p, && li, && a, && blockquote, && strong, && em":
                {
                  color: "common.white",
                },
            }
          : {}),
      }}
      onClick={(event) => {
        // Expanding the disclosure remains interactive in an otherwise inert preview.
        // Puck's iframe has its own Element constructor.
        const ElementClass = event.currentTarget.ownerDocument.defaultView?.Element;
        if (
          inert &&
          ElementClass &&
          event.target instanceof ElementClass &&
          event.target.closest("a")
        ) {
          event.preventDefault();
        }
      }}
    >
      <Box
        component="summary"
        sx={{
          cursor: "pointer",
          fontWeight: supporting ? 700 : 600,
          textAlign: supporting ? "left" : "center",
          width: supporting ? "auto" : "fit-content",
          mx: supporting ? 0 : "auto",
          ...(supporting
            ? {
                color: onBrand ? "white" : "primary.main",
                fontSize: ".82rem",
                textDecoration: "underline",
                textUnderlineOffset: "2px",
              }
            : {}),
        }}
      >
        {label.trim() || "Sponsored Schools Disclosure"}
      </Box>
      <Box sx={{ mt: 1.5 }}>
        <FormFunnelRichText content={hydratePuckRichTextMedia(content, media)} tone="finePrint" />
      </Box>
    </Box>
  );
}
